<template>
    <div v-show="editShow">
        <div class="container">
            <el-row :gutter="20">
                <div class="clearfix">
                    <div class="crumbs">
                        <i class="el-icon-back"></i>
                        <el-button type="text" @click="goBack">返回</el-button>
                    </div>
                    <div class="btn-save">
                        <el-button type="primary" @click="saveClick('formData')"
                        >保存
                        </el-button
                        >
                    </div>
                </div>
                <div class="form-box">
                    <el-form
                            :model="formData"
                            :rules="rules"
                            ref="formData"
                            label-width="120px"
                            class="eidt-el-form"
                    >
                        <el-form-item label="酒店" prop="projectHotelId">
                            <el-select
                                    v-model="formData.projectHotelId"
                                    placeholder="请选择酒店"
                            >
                                <el-option
                                        v-for="(type, index) in projectHotel"
                                        :label="type.name"
                                        :key="index"
                                        :value="type.projectHotelId"
                                >
                                    <div @click="getChangeType(type)">{{ type.name }}</div>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="类型名称" prop="name">
                            <el-input v-model="formData.name"></el-input>
                        </el-form-item>
                        <el-form-item label="入住人数" prop="personal">
                            <el-input-number min="0" v-model="formData.personal"></el-input-number>
                        </el-form-item>
                        <el-form-item label="房间数据" prop="number">
                            <el-input-number min="0" v-model="formData.number"></el-input-number>
                        </el-form-item>
                        <el-form-item label="开始时间" prop="startDate">
                            <el-date-picker
                                    v-model="formData.startDate"
                                    type="datetime"
                                    placeholder="开始日期"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="结束时间" prop="endDate">
                            <el-date-picker
                                    v-model="formData.endDate"
                                    type="datetime"
                                    placeholder="结束日期"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="禁用/启用" prop="disabled">
                            <el-radio-group v-model="formData.disabled">
                                <el-radio :label="true">禁用</el-radio>
                                <el-radio :label="false">启用</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>
                </div>
            </el-row>
        </div>
    </div>
</template>

<script>
    import bus from "../common/bus";

    export default {
        name: "edit_project_room_type",
        data() {
            return {
                rules: {
                    name: [{required: true, message: "请填写名称", trigger: "blur"}],
                    startDate: [{required: true, message: "开始时间不能为空", trigger: "blur"}],
                    endDate: [{required: true, message: "结束时间不能为空", trigger: "blur"}],
                    projectHotelId: [
                        {required: true, message: "请选择酒店", trigger: "blur"},
                    ],
                    number: [
                        {required: true, message: "请输入房间数量", trigger: "blur"},
                    ],
                    personal: [
                        {required: true, message: "请输入入住人数", trigger: "blur"},
                    ],
                },
                formData: {
                    name: "",
                    personal: 0,
                    number: 0,
                    startDate: null,
                    endDate: null,
                    disabled: false,
                    projectHotelId: null,
                    projectId: localStorage.getItem("project_Id"),
                },
                projectHotelId: null,
                projectRoomTypeId: null,
                admin: "",
                projectHotel: [],
                project_Id: localStorage.getItem("project_Id"),
            };
        },
        props: {
            editShow: {
                type: Boolean,
                default: false,
            },
            arrarList: {
                type: Array,
                default() {
                    return [];
                },
            },
            editData: {
                type: Object,
            },
        },
        watch: {
            editData: function () {
                const item = this.editData;
                if (item) {
                    this.formData = item;
                    this.projectRoomTypeId = item.projectRoomTypeId;
                }
            },
        },
        created() {
            bus.$on("getPTypeId", (message) => {
                this.projectHotelId = message;
            });
            this.getProjectHotel();
        },
        methods: {
            getProjectHotel() {
                this.$axios.get("/ProjectHotel/Project/" + this.project_Id).then((res) => {
                    if (res.data.hasError == false) {
                        this.projectHotel = [...res.data.data];
                    }
                });
            },
            getChangeType(type) {
                this.projectHotelId = type.projectHotelId;
            },
            saveClick(formData) {
                var state_date = null;
                if (this.formData.startDate) {
                    try {
                        var s = new Date(this.formData.startDate);
                        state_date = s.getFullYear() +
                            "-" +
                            (s.getMonth() + 1) +
                            "-" +
                            (s.getDate() < 10 ? "0" + s.getDate() : s.getDate()) +
                            " " +
                            s.getHours() +
                            ":" +
                            s.getMinutes() +
                            ":" +
                            s.getSeconds();
                    } catch (e) {
                        startDate = this.formData.startDate;
                    }
                }

                var end_date = null;
                if (this.formData.endDate) {
                    try {
                        var e = new Date(this.formData.endDate);
                        end_date = e.getFullYear() +
                            "-" +
                            (e.getMonth() + 1) +
                            "-" +
                            (e.getDate() < 10 ? "0" + e.getDate() : e.getDate()) +
                            " " +
                            e.getHours() +
                            ":" +
                            e.getMinutes() +
                            ":" +
                            e.getSeconds();
                    } catch (e) {
                        end_date = this.formData.endDate;
                    }
                }
                this.formData.startDate = state_date;
                this.formData.endDate = end_date;
                this.formData.projectId = this.project_Id;

                this.$refs[formData].validate((valid) => {
                    if (valid) {
                        if (!this.projectRoomTypeId) {
                            this.$axios.post("/ProjectRoomType/", this.formData).then((res) => {
                                if (res.data.hasError == false) {
                                    this.$message.success("保存成功！");
                                    this.$refs[formData].resetFields();
                                    this.goBack();
                                } else {

                                  this.$message.error(res.data.message);                                }
                            });
                        } else {
                            this.$axios
                                .put("/ProjectRoomType/" + this.projectRoomTypeId, this.formData)
                                .then((res) => {
                                    if (res.data.hasError == false) {
                                        this.$message.success("编辑成功！");
                                        this.$refs[formData].resetFields();
                                        this.goBack();
                                    } else {

                                      this.$message.error(res.data.message);                                    }
                                });
                        }
                    } else {
                        return false;
                    }
                });
            },
            goBack() {
                this.projectRoomTypeId = "";
                this.admin = "";
                this.editImg = "";
                this.editImg1 = "";
                this.$emit("backFunStu");
                this.$refs["formData"].resetFields();
            },
        }
    };
</script>

<style lang="scss">
    .container {
        margin-bottom: 10px;
    }

    .el-inpt-phone {
        width: calc(100% - 70px);
    }

    .jc-btn {
        position: absolute;
        width: 60px;
        right: 0;
    }
</style>